export default __webpack_public_path__ + "static/media/accelerate2.17c372b2.webp";